import { api } from "src/Basic/ApiFetch";
import { showGlobalMessageBox, getGlobalServerConfig } from "src/Route/RootMiddleware";

export const getCaptchaService = async () => {
    const initCaptchaEncode = { CaptchaEncode: "" };
    let url = getGlobalServerConfig().backEndUrl.get() + 'Login/LoadCapcha';
    let captchaData = { ...initCaptchaEncode };
    let response = await api.Get(url, null, null, false);
    if (response.ok) {
        captchaData = await response.json();
        return captchaData;
    } else {
        showGlobalMessageBox("無法獲取驗證碼，請稍後重試。");
        return null;
    }
};
